var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[_c('md-empty-state',{attrs:{"md-rounded":"","md-icon":"travel_explore","md-label":"No Page Found","md-description":"Maybe Check your URL?"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }